// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_BigInt from "../Data.BigInt/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Fusion_Util from "../Fusion.Util/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var add = /* #__PURE__ */ Data_Semiring.add(Data_BigInt.semiringBigInt);
var zero = /* #__PURE__ */ Data_Semiring.zero(Data_BigInt.semiringBigInt);
var mul = /* #__PURE__ */ Data_Semiring.mul(Data_BigInt.semiringBigInt);
var bind = /* #__PURE__ */ Control_Bind.bind(Test_QuickCheck_Gen.bindGen);
var arbitrary = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbInt);
var pure = /* #__PURE__ */ Control_Applicative.pure(Test_QuickCheck_Gen.applicativeGen);
var sub2 = /* #__PURE__ */ Data_Ring.sub(Data_BigInt.ringBigInt);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showNumber);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var secondsIsSymbol = {
    reflectSymbol: function () {
        return "seconds";
    }
};
var nanosIsSymbol = {
    reflectSymbol: function () {
        return "nanos";
    }
};
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonNumber))(Data_Argonaut_Decode_Class.gDecodeJsonNil)(secondsIsSymbol)()())(nanosIsSymbol)()())());
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Data_Either.bindEither);
var when = /* #__PURE__ */ Control_Applicative.when(Data_Either.applicativeEither);
var lessThan = /* #__PURE__ */ Data_Ord.lessThan(Data_BigInt.ordBigInt);
var greaterThanOrEq = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Data_BigInt.ordBigInt);
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(Control_Monad_Error_Class.monadThrowEither);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonInt);
var encodeJson1 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_BigInt.euclideanRingBigInt);
var div1 = /* #__PURE__ */ Data_EuclideanRing.div(Data_BigInt.euclideanRingBigInt);
var gEncodeJsonCons = /* #__PURE__ */ Data_Argonaut_Encode_Class.gEncodeJsonCons(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var encodeJson2 = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(/* #__PURE__ */ Data_Argonaut_Encode_Class.encodeRecord(/* #__PURE__ */ gEncodeJsonCons(/* #__PURE__ */ gEncodeJsonCons(Data_Argonaut_Encode_Class.gEncodeJsonNil)(secondsIsSymbol)())(nanosIsSymbol)())());
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var jsonCodec = /* #__PURE__ */ Fusion_Util.jsonCodec(Data_Argonaut_Decode_Class.decodeJsonNumber)(Data_Argonaut_Encode_Class.encodeJsonJNumber);
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var Duration = function (x) {
    return x;
};
var showDuration = {
    show: function (v) {
        return "(D.fromStr \"" + (Data_BigInt.toString(v) + "\")");
    }
};
var semigroupDuration = {
    append: function (v) {
        return function (v1) {
            return add(v)(v1);
        };
    }
};
var ordDuration = Data_BigInt.ordBigInt;
var monoidDuration = {
    mempty: zero,
    Semigroup0: function () {
        return semigroupDuration;
    }
};
var eqDuration = Data_BigInt.eqBigInt;
var durationDuration = {
    fromDuration: function (v) {
        var numInNano = Data_BigInt.toNumber(v);
        var numInMs = numInNano / 1000000.0;
        return numInMs;
    },
    toDuration: function (v) {
        var wholePart = Data_Number.floor(v);
        var wholePartNanos = mul(Data_Maybe.fromMaybe(zero)(Data_BigInt.fromNumber(wholePart)))(Data_BigInt.fromInt(1000000));
        var fractionalPart = v - wholePart;
        var fractionalPartNanos = Data_Maybe.fromMaybe(zero)(Data_BigInt.fromNumber(fractionalPart * 1000000.0));
        return add(wholePartNanos)(fractionalPartNanos);
    }
};
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(durationDuration)(Data_Time_Duration.durationSeconds);
var convertDuration1 = /* #__PURE__ */ Data_Time_Duration.convertDuration(Data_Time_Duration.durationSeconds)(durationDuration);
var toDuration = /* #__PURE__ */ Data_Time_Duration.toDuration(durationDuration);
var arbitraryDuration = {
    arbitrary: /* #__PURE__ */ bind(arbitrary)(function (v) {
        return bind(arbitrary)(function (v1) {
            return bind(arbitrary)(function (v2) {
                return pure(mul(mul(Data_BigInt.fromInt(v))(Data_BigInt.fromInt(v1)))(Data_BigInt.fromInt(v2)));
            });
        });
    })
};
var toOld = function (v) {
    return v;
};
var sub = function (v) {
    return function (v1) {
        return sub2(v)(v1);
    };
};
var strCodecSeconds = /* #__PURE__ */ (function () {
    var enc = function (dur) {
        var v = convertDuration(dur);
        return show(v);
    };
    var dec = function (str) {
        return bind1(Data_Either.note("Expecting a number")(Data_Number.fromString(str)))(function (num) {
            var dur = convertDuration1(num);
            return pure1(dur);
        });
    };
    return Data_Codec["codec$prime"](dec)(enc);
})();
var scale = function (factor) {
    return function (v) {
        return mul(v)(Data_BigInt.fromInt(factor));
    };
};
var quot = /* #__PURE__ */ Safe_Coerce.coerce()(Data_BigInt.quot);
var prettyPrint = function (v) {
    var padStart = function (s) {
        var padLength = 6 - Data_String_CodePoints.length(s) | 0;
        var padString = Data_String_CodePoints.take(padLength)("000000");
        return padString + s;
    };
    var millis = Data_BigInt.quot(v)(Data_BigInt.fromInt(1000000));
    var micros = Data_BigInt.rem(v)(Data_BigInt.fromInt(1000000));
    return Data_BigInt.toString(millis) + ("." + (padStart(Data_BigInt.toString(micros)) + "ms"));
};
var nanosPerSecond = /* #__PURE__ */ Data_BigInt.fromInt(1000000000);
var decodeJsonDuration = {
    decodeJson: function (json) {
        return bind1(decodeJson(json))(function (v) {
            var nanosBi = Data_BigInt.fromInt(v.nanos);
            return discard(when(lessThan(nanosBi)(zero) || greaterThanOrEq(nanosBi)(nanosPerSecond))(throwError(new Data_Argonaut_Decode_Error.AtKey("nanos", new Data_Argonaut_Decode_Error.UnexpectedValue(encodeJson(v.nanos))))))(function () {
                return bind1(Data_Either.note(new Data_Argonaut_Decode_Error.AtKey("seconds", new Data_Argonaut_Decode_Error.UnexpectedValue(encodeJson1(v.seconds))))(Data_BigInt.fromNumber(v.seconds)))(function (v1) {
                    return pure1(add(mul(v1)(nanosPerSecond))(nanosBi));
                });
            });
        });
    }
};
var encodeJsonDuration = {
    encodeJson: function (v) {
        var nanos = mod(v)(nanosPerSecond);
        var seconds = div1(v)(nanosPerSecond);
        return encodeJson2({
            seconds: Data_BigInt.toNumber(seconds),
            nanos: Data_BigInt.toNumber(nanos)
        });
    }
};
var jsonCodecSeconds = /* #__PURE__ */ (function () {
    var enc = function (dur) {
        return encodeJson1(unwrap(convertDuration(dur)));
    };
    var dec = function (json) {
        return bind1(Data_Codec.decode(jsonCodec)(json))(function (num) {
            var dur = convertDuration1(num);
            return pure1(dur);
        });
    };
    return Data_Codec["codec$prime"](dec)(enc);
})();
var fromStr = function () {
    return function (str) {
        return fromJust(Data_BigInt.fromString(str));
    };
};
var fromOld = function (v) {
    return v;
};
var fromMs = function (ms) {
    return toDuration(ms);
};
export {
    fromMs,
    fromOld,
    fromStr,
    jsonCodecSeconds,
    prettyPrint,
    quot,
    scale,
    strCodecSeconds,
    sub,
    toOld,
    durationDuration,
    semigroupDuration,
    monoidDuration,
    showDuration,
    eqDuration,
    ordDuration,
    decodeJsonDuration,
    encodeJsonDuration,
    arbitraryDuration
};
